import ContainerMembroCheckin from './Components/container';
import { ProviderMembrosCheckin } from './context/getMembros';

export default function MembrosCheckin() {

  return (
    <>
      <ProviderMembrosCheckin>
        <div style={{ display: "flex", flex: 1, padding: 5 }}>
          <ContainerMembroCheckin />
        </div>
      </ProviderMembrosCheckin>
    </>
  )
}
